import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTaxi, faTree, faBullhorn, faBuilding, faUtensils,
} from '@fortawesome/free-solid-svg-icons';

function ServiceComponentIcon({
    service, className,
})
{
    const icons = {
        Transfer: faTaxi,
        Excursion: faTree,
        Dinner: faUtensils,
        Hotel: faBuilding,
        Other: faBullhorn,
    };

    const icon = icons[service] ?? faBullhorn;

    return (
        <FontAwesomeIcon className={className} icon={icon} />
    );
}

ServiceComponentIcon.propTypes = {
    className: PropTypes.string,
    service: PropTypes.string.isRequired,
};

export default ServiceComponentIcon;
